import { useParams } from "react-router-dom";
import { getOneCategory } from "../../api-route/categorys";
import Category from "../../Components/categories-section/Category";
import HeroHeader from "../../Components/hero-header-section/index.section";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { BaseURL } from "../../config/axios";

const Index = () => {
    const { slug } = useParams()
    const [currentPage, setCurrentPage] = useState(1)
    const [category, setCategory] = useState()
    const [painting, setPainting] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const pagination = useRef()

    useEffect(() => {
        const get = async () => {
            if (!slug) return; // Ensure `slug` is defined

            try {
                const data = await getOneCategory(slug, { page: currentPage });
                if (data) {
                    const { paintings, ...other } = data || {}
                    setCategory(other || [])
                    setPainting(data ? paintings.data : [])
                    pagination.current = data ? Math.ceil(data.paintings.total / data.paintings.per_page) : 1
                    console.log('salam', data);
                    
                } else {
                    setError("دسته بندی پیدا نشد");
                }
            } catch (err) {
                setError("مشکل در بارگزاری اطلاعات");
            } finally {
                setLoading(false);
            }
        }
        get()
    }, [slug, currentPage]);

    if (loading) {
        return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
    }

    if (error) {
        return <div className="centerOfParent h-screen w-full">{error}</div>;
    }

    if (!category) {
        return <div className="centerOfParent h-screen w-full">اطلاعاتی از این دسته بندی در دسترس نیست</div>;
    }

    const generalSchema = {
        "@context": "https://schema.org/",
        "@type": "CollectionPage",
        "itemListElement": painting.map(p => {
            return {
                "@type": "ListItem",
                "position": 1,
                "url": `https://tonaliteh.com/product/${p.slug}`,
                "item": {
                    "@type": "Product",
                    "name": p.title,
                    "description": p.body,
                    "image": BaseURL + p.images[0]?.path,
                    "offers": {
                        "@type": "Offer",
                        "priceCurrency": "IRR",
                        "price": 2000000
                    }
                }
            }
        })
    }

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(generalSchema)}
                </script>
            </Helmet>
            {!!category ? <main className="flex flex-col">
                <HeroHeader {...category} breadcrumb={[{ slug: 'categories', name: 'دسته بندی ها' }, { name: category.title }]} />
                <Category {...{ painting, pagination, category, setCurrentPage, currentPage }} />
            </main> : <div className="centerOfParent">درحال بارگزاری...</div>}
        </>
    );
};

export default Index;